import { useState } from "react";
import { observer } from "mobx-react";
import trophy from '../../../../assets/icons/trophy.svg';
import { utilsStore } from "../../../../platform/stores";
import { useTranslation } from "../../../../platform/stores/translationStore";
import '../free-bet.scss';

export const FreeBetEnd = observer(() => {
  const { freeBetEndData, setFreeBetEndData } = utilsStore;
  const [closing, setClosing] = useState(false);
  const t = useTranslation();

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setFreeBetEndData(undefined);
      setClosing(false);
    }, 250);
  };

  if (!freeBetEndData) return null;

  return (
    <div className={`free-bet-overlay${closing ? ' closing' : ''}`}>
      <div className="free-bet-backdrop" onClick={handleClose} />
      <div className={`free-bet-card${closing ? ' closing' : ''}`}>
        <button className="close-btn" onClick={handleClose} aria-label={t('FREE_BET_CLOSE')}>✕</button>

        <div className="free-bet-icon-wrapper">
          <img src={trophy} alt={t('FREE_BET_ICON_TROPHY_ALT')} />
        </div>

        <div className="free-bet-badge">{t('FREE_BET_BADGE')}</div>

        {freeBetEndData.winAmount > 0 ? (
          <>
            <h2>{t('FREE_BET_END_TOTAL_PROFIT')}</h2>
            <div className="free-bet-amount">{freeBetEndData.winAmount}</div>
            <div className="free-bet-currency">{freeBetEndData.currency}</div>
          </>
        ) : (
          <>
            <h2>{t('FREE_BET_END_NO_WIN')}</h2>
            <h3>{t('FREE_BET_END_NO_WIN_SUB')}</h3>
          </>
        )}

        <div className="free-bet-divider" />

        <button className="free-bet-btn" onClick={handleClose}>
          {t('FREE_BET_END_CONTINUE')}
        </button>
      </div>
    </div>
  );
});
